import * as React from 'react';
import { cn, Title } from 'sg-styleguide';

import './filter-button.scss';
const FilterButton = ({
	title,
	className = '',
	selected,
	onClick,
	...props
}) => {
	const classes = cn(
		className,
		'filter--button',
		selected && 'filter--button-selected',
	);

	return (
		<Title
			level="5"
			density="none"
			weight="regular"
		>
			<a
				className={classes}
				href="#"
				onClick={onClick}
			>
				{title}
			</a>
		</Title>
	);
};

export default FilterButton;
